/**
 * Maps a browse-table sort key and direction to Spatie's sort format (`-field` for DESC).
 */
export function buildSpatieSort<T extends string>(
  sortKey: string,
  order: "ASC" | "DESC",
  allowedFields: readonly T[],
  fallback: T,
  customDataPattern?: RegExp,
): T | `-${T}` | string {
  const bare = sortKey.replace(/^-/, "");

  if (allowedFields.includes(bare as T)) {
    return order === "DESC" ? (`-${bare}` as `-${T}`) : (bare as T);
  }

  if (customDataPattern?.test(bare)) {
    return order === "DESC" ? `-${bare}` : bare;
  }

  return order === "DESC" ? (`-${fallback}` as `-${T}`) : fallback;
}
